import React from 'react'
import {OrderCardHeader, ProductListHeader} from '../shared'
import ProductListItem from './product/ProductListItem'
import SearchProducts from '../shared/search/SearchProducts'

interface Props {
  items: Array<any>
  title?: string | any
  subTitle?: any
  onAddProduct?: (products: any) => void
  onRemoveItem: (item: any) => void
  onUpdateItem: (item: any) => void
  hideSearchBar?: boolean
  isRefundMode?: boolean
  isDisableInput?: boolean
  toolbar?: any
  children?: React.ReactNode
  orderDeliveryMethod?: any
  isRefundDiscountValidate?: boolean
  isEditMode?: boolean
}

export const EditOrderItems: React.FC<Props> = ({
  items,
  title = 'Add Products',
  subTitle,
  onAddProduct,
  hideSearchBar,
  isRefundMode,
  isDisableInput,
  toolbar,
  children,
  orderDeliveryMethod,
  isEditMode,
  ...props
}) => {
  const handleAdd = (products: any) => {
    if (onAddProduct) {
      onAddProduct(products)
    }
  }
  return (
    <div className='card shadow-lg rounded-10 mb-7'>
      {toolbar ? (
        <OrderCardHeader
          title={title}
          subTitle={subTitle}
          hideSearchBar={hideSearchBar}
          itemsCount={!isRefundMode ? 0 : items.length}
          search={<SearchProducts onAddProduct={handleAdd} items={items} />}
        >
          {toolbar}
        </OrderCardHeader>
      ) : (
        <OrderCardHeader
          title={title}
          subTitle={subTitle}
          hideSearchBar={hideSearchBar}
          itemsCount={!isRefundMode ? 0 : items.length}
          search={<SearchProducts onAddProduct={handleAdd} items={items} />}
        />
      )}
      <ProductListHeader isEditMode hideHeader={items.length === 0}>
        {items.map((order) => {
          return (
            <ProductListItem
              orderItem={order}
              {...props}
              key={order.variantId}
              orderDeliveryMethod={orderDeliveryMethod}
              isRefundMode={isRefundMode}
              isDisableInput={isDisableInput}
              isEditMode={isEditMode}
            />
          )
        })}
      </ProductListHeader>
      {children && <div className='card-footer'>{children}</div>}
    </div>
  )
}

export default EditOrderItems
